module.exports = [{"code":"Food","Desc_en":"Food"},{"code":"Beverage","Desc_en":"Beverage"},{"code":"Food & Beverage","Desc_en":"Food & Beverage"},{"code":"Snack","Desc_en":"Snack"},{"code":"Bakery & Dessert","Desc_en":"Bakery & Dessert"},{"code":"Clothing and Apparel","Desc_en":"Clothing and Apparel"},{"code":"Handicraft","Desc_en":"Handicraft"},{"code":"Convenience Store","Desc_en":"Convenience Store"}]


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/e-invoice/Description.json
// module id = 9gwv
// module chunks = 50